import { kevinAuthAPI, kevinCommonAPI } from 'apis/config';
import { IDress } from 'utils/types/storyTypes';

// * 2023.12.11 정비 완료
export const costumeApis = {
  costumeList: (projectId): Promise<IDress[]> =>
    kevinCommonAPI
      .get(`/resource-manager/costume/${projectId}/`)
      .then((res) => res.data.list),
  costumeCreate: (projectId, data) =>
    kevinAuthAPI
      .post(`/resource-manager/costume/${projectId}`, data)
      .then((res) => res.data),
  costumeUpdate: (projectId, dressId, data) =>
    kevinAuthAPI
      .patch(`/resource-manager/costume/${projectId}/${dressId}`, data)
      .then((res) => res.data),
  costumeDelete: (projectId, dressId) =>
    kevinAuthAPI
      .delete(`/resource-manager/costume/${projectId}/${dressId}`)
      .then((res) => res.data),
};
